var map = {
	"./bathtub.png": [
		4595,
		595
	],
	"./fountain.png": [
		236,
		236
	],
	"./radiator.png": [
		6611,
		611
	],
	"./shower.png": [
		3584,
		584
	],
	"./tiles.png": [
		4663,
		663
	],
	"./toilet.png": [
		462,
		462
	],
	"./utilities.png": [
		6605,
		605
	],
	"./washbasin.png": [
		1812,
		812
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3059;
module.exports = webpackAsyncContext;